// extracted by mini-css-extract-plugin
export var cardHeader = "_fq-0";
export var reorderHandle = "_fq-3";
export var titleArea = "_fq-1";
export var titleAreaWithHandle = "_fq-2";